import { render, staticRenderFns } from "./LiveingCenter.vue?vue&type=template&id=434ebda2&scoped=true"
import script from "./LiveingCenter.vue?vue&type=script&lang=js"
export * from "./LiveingCenter.vue?vue&type=script&lang=js"
import style0 from "./LiveingCenter.vue?vue&type=style&index=0&id=434ebda2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434ebda2",
  null
  
)

export default component.exports